// export const formatLocalTime = (utcDate) => {
//   if (!utcDate) return "";

//   const date = new Date(utcDate);
//   if (isNaN(date.getTime())) return "";

//   return new Intl.DateTimeFormat(undefined, {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   }).format(date);
// };
export function formatLocalTime(dateString) {

  if (!dateString) return "";

  const date = new Date(dateString);
  const now = new Date();

  const isToday =
    date.toDateString() === now.toDateString();

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  const isYesterday =
    date.toDateString() === yesterday.toDateString();

  const time = date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit"
  });

  if (isToday) return time;

  if (isYesterday) return `Yesterday, ${time}`;

  return date.toLocaleDateString([], {
    day: "2-digit",
    month: "short",
    year: "numeric"
  }) + `, ${time}`;
}

export function formatLocalDate(dateString) {
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date();

  yesterday.setDate(today.getDate() - 1);

  const isToday =
    date.toDateString() === today.toDateString();

  const isYesterday =
    date.toDateString() === yesterday.toDateString();

  if (isToday) return "Today";
  if (isYesterday) return "Yesterday";

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}